var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBreakfast = function SvgBreakfast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "breakfast_svg__a",
    width: 24,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .094h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#breakfast_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 20.094a.96.96 0 0 1-.7-.3.96.96 0 0 1-.3-.7V9.969a5.5 5.5 0 0 1-1.413-1.213A2.53 2.53 0 0 1 3 7.094q0-1.25.875-2.125A2.9 2.9 0 0 1 6 4.094h12q1.25 0 2.125.875.875.874.875 2.125 0 .95-.587 1.662-.588.713-1.413 1.213v9.125q0 .4-.3.7t-.7.3zm0-1h12v-9.7l.55-.325q.55-.35 1-.838.45-.487.45-1.137 0-.824-.587-1.412A1.93 1.93 0 0 0 18 5.094H6q-.824 0-1.412.588A1.92 1.92 0 0 0 4 7.094q0 .675.45 1.15t1 .825l.55.325zm5.6-2.575a.55.55 0 0 0 .4.175.55.55 0 0 0 .4-.175l3.075-3.025q.15-.175.15-.4t-.15-.4L12.4 9.619a.6.6 0 0 0-.4-.15q-.225 0-.4.15l-3.025 3.075a.55.55 0 0 0-.175.4q0 .225.175.4zm.4-1.025-2.4-2.4 2.4-2.45 2.45 2.45z"
  }))));
};
export default SvgBreakfast;